import { pick } from './i18n.js';

const zh = {
  reference: '参考',
  deliverable: '成果',
  intermediate: '中间产物',
  evidence: '过程证据',
};
const en: typeof zh = {
  reference: 'Reference',
  deliverable: 'Deliverable',
  intermediate: 'Intermediate output',
  evidence: 'Working evidence',
};
export const artifactPresentationTextByLocale = { zh, en };
export const artifactPresentationText = pick<typeof zh>(artifactPresentationTextByLocale);
